export const popupClassNames =
  'min-w-[8em] bg-white py-1 will-change-[opacity,transform] data-[side=bottom]:animate-slideUpAndFade data-[side=left]:animate-slideRightAndFade data-[side=right]:animate-slideLeftAndFade data-[side=top]:animate-slideDownAndFade max-h-[300px] overflow-y-auto border outline-none';
export const itemClassNames =
  'group relative flex select-none items-center px-3 py-2 leading-none text-primary outline-none hover:cursor-pointer data-[disabled=true]:pointer-events-none data-[highlighted]:bg-orange-20 data-[highlighted]:text-primary-dark hover:bg-grey-20 data-[selected=true]:text-primary-dark';

export const dropdownIconSize = 16;

export const separatorClassNames = 'mx-3 my-1 h-[1px] bg-accent-500/40';
